import Vue from 'vue'
import VueRouter from 'vue-router'
import GetAQuote from "../components/GetAQuote";
import MultipleQuotation from "@/views/MultipleQuotation";
import TermCoverage from "@/views/TermCoverage";
import ChatDisclaimerDialog from "../components/ChatDisclaimerDialog";
import SymmRAQ from "../components/SymmRAQ";
import SymmetryLayout from "../components/Symmetry";
// import MyQuility from "../components/MyQuility"
import Thankyou from "../components/Thankyou"
import HatchThankyou from "../components/HatchThankyou"
// import DemoTermCovCalc from "@/views/DemoTermCovCalc";
import OTPVerify from "../components/OTPVerify"
import NoQuoutes from "@/components/NoQoutes"

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'GetAQuote',
        component: GetAQuote
    },
    {
        path: '/termQuote',
        name: 'TermCoverage',
        component: TermCoverage
    },
    {
        path: '/quotes',
        name: 'multiple-quotes',
        component: MultipleQuotation
    },
    {
        path: '/quotes',
        name: 'multiple-quotes-edited',
        component: MultipleQuotation
    },
    {
        path: '/chat-disclaimer',
        name: 'Chat-Disclaimer',
        component: ChatDisclaimerDialog
    },
    {
        path: '/symmetry/raq/:agent_code',
        name: 'Symm-raq',
        component: SymmetryLayout,
        children: [
            {
                path: '/',
                name: 'Symm-form',
                component: SymmRAQ
            }
        ]
    },
    {
        path: '/symmetry/quotes',
        name: 'Symm-quotes',
        component: MultipleQuotation
    },
    {
        path:'/symmetry/quotes',
        name:'Symm-quotes-edited',
        component: MultipleQuotation
    },
    // {
    //     path: '/myquility/:state/:agent_code',
    //     name: 'myquility',
    //     component: MyQuility
    // },
    {
        path: '/thankyou',
        name: 'Thankyou',
        component: Thankyou
    },
    {
        path: '/symmetry/thankyou',
        name: 'HatchThankyou',
        component: HatchThankyou
    },
    // {
    //     path: '/demotermcovcalc',
    //     name: 'DemoTermCovCalc',
    //     component: DemoTermCovCalc
    // },
    {
        path: '/verify',
        name: 'Verify',
        component: OTPVerify
    },
    {
        path: '/quotes-thank-you',
        name: 'QuotesThankYou',
        component: NoQuoutes
    },
    {
        path:'/results',
        name:'Results',
        component: MultipleQuotation
    },
]

const router = new VueRouter({
    routes
})

export default router
